import { animated } from '@react-spring/web'
import { useCallback, useContext, useMemo } from 'react'

import { FrameBuilderStringsContext } from '@frame-builder/contexts/strings-context'
import { FrameBuilderValidationContext } from '@frame-builder/contexts/validation-context'
import { useBlinkingState } from '@frame-builder/lib/preview-animation'
import { type StepDefinitionProps } from '@frame-builder/lib/steps'

import Button from '@frame-builder/components/utility/button'
import ListContainer from '@frame-builder/components/utility/list-container'
import ConfigurationDefinition from '../configuration-definition'
import PassepartoutColorList from './passepartout-color-list'

const PassepartoutDefinition = ({
  stepNumber,
  onClose,
  className,
}: StepDefinitionProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { validationErrorMessages } = useContext(FrameBuilderValidationContext)

  const [opacity, setIsBlinking] = useBlinkingState()

  const isValidSelection = useMemo(() => {
    return (
      !validationErrorMessages?.passepartoutColorPreview &&
      !validationErrorMessages?.passepartoutSizePreview
    )
  }, [validationErrorMessages])

  const handleOkClick = useCallback(() => {
    if (isValidSelection) {
      onClose()
    }

    if (!isValidSelection) {
      setIsBlinking(true)
    }
  }, [isValidSelection, onClose, setIsBlinking])

  return (
    <ConfigurationDefinition
      stepNumber={stepNumber}
      title={frameBuilderStrings.passepartoutStepTitle}
      footerContent={frameBuilderStrings.passepartoutStepFooter}
      onClose={onClose}
      className={className}
    >
      <div className="flex flex-col px-5 space-y-5">
        <animated.div
          style={{
            opacity,
          }}
        >
          <ListContainer gapSize="sm">
            <PassepartoutColorList />
          </ListContainer>
        </animated.div>

        <div>
          <Button
            size="small"
            isVisuallyDisabled={!isValidSelection}
            onClick={handleOkClick}
            className="min-w-32 grow-0 shrink-0"
          >
            {frameBuilderStrings.controlOkLabel}
          </Button>
        </div>
      </div>
    </ConfigurationDefinition>
  )
}

export default PassepartoutDefinition
